import React from "react";
import { maskName, maskPhone } from "../../../utils/newyear/masks";

const MaskedText = ({ value, type = "text", showOriginal = false }) => {
  if (!value) return null;

  let displayValue = value;

  if (!showOriginal) {
    switch (type) {
      case "name":
        displayValue = maskName(value);
        break;
      case "phone":
        displayValue = maskPhone(value);
        break;
      default:
        displayValue = value;
    }
  }

  return <span className="newyear-masked-text">{displayValue}</span>;
};

export default MaskedText;
